import apiFetch from '../apiFetch'

export default function (token, id) {
  return apiFetch({ endPoint: `MetadataList/${id}`, method: 'DELETE', body: null, token: token })
}
